import React from "react";

export default function Close() {
    const svg = `
<svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="X" stroke="#000000" stroke-width="2">
            <circle id="Oval" cx="20" cy="20" r="19"></circle>
            <line x1="11.5" y1="20.5" x2="27.5" y2="20.5" id="Line" stroke-linecap="round" stroke-linejoin="round" transform="translate(19.500000, 20.500000) rotate(45.000000) translate(-19.500000, -20.500000) "></line>
            <line x1="11.5" y1="20.5" x2="27.5" y2="20.5" id="Line-Copy" stroke-linecap="round" stroke-linejoin="round" transform="translate(19.500000, 20.500000) scale(-1, 1) rotate(45.000000) translate(-19.500000, -20.500000) "></line>
        </g>
    </g>
</svg>`;

    return (
        <i dangerouslySetInnerHTML={{__html: svg}}/>
    )
}